import { isProduction } from '../util/environment'

export function getPublicKey() {
  if (isProduction()) {
    return 'pk_live_51H4MPDFcoAPn4NC2KsdipmAoSHQR5DpTOXYIJMzyh3Z97Xq6Jf0I2C46P8AvxodQo2iRUCDPizp8NvvmvE1bcEcw00UjGEJ121'
  } else {
    return 'pk_test_51H4MPDFcoAPn4NC2jRESp5TPdcErzDeIX7z3GZNwIgQW4yR4NWjtVt9jhkuobfdUjgbLDzqFWfGBJU3LyKdOJkes00t9Aclfan'
  }
}
